import DraggableModal from "./DraggableModal";


const PurchaseInfoModal = ({ showPurchaseInfoModal, setShowPurchaseInfoModal, purchaseInfoImage}) => {
    return (
        <DraggableModal show={showPurchaseInfoModal} setShow={setShowPurchaseInfoModal} headerHeight={70} titleStyle={'bg-[#bed6ff] rounded-t-[8px]'}>
            <div className={'w-[700px] h-[550px]'}>
                <img src={purchaseInfoImage} alt={'homework'} className={'w-full'}/>
                <div className={'flex justify-center mt-[30px]'}>
                    <a target={'_blank'} href={'https://i-screammall.co.kr/goods/detail/10028021'}
                       className={'w-[160px] h-[60px] bg-[#5a85ff] text-[#ffffff] rounded-full flex justify-center items-center text-[20px] font-[pd-b] cursor-pointer'}>상품 보기</a>
                    <div onClick={() => setShowPurchaseInfoModal(false)}
                         className={'w-[160px] h-[60px] bg-[#D9D9D9] text-[#50555F] rounded-full flex justify-center items-center text-[20px] font-[pd-b] cursor-pointer ml-[40px]'}>닫기
                    </div>
                </div>
            </div>
        </DraggableModal>
    )

}

export default PurchaseInfoModal;